module.exports = __webpack_public_path__ + "static/media/menos 15.c29ed417.png";